/**
 * Страница менеджера: список пользователей (manager/users).
 *
 * Маркер инициализации — таблица [data-sync-columns="users-list"].
 *
 * Функционал:
 *   - поиск по таблицам пользователей (по всему тексту строки);
 *   - toggle поля поиска (active class);
 *   - dropdown проектов (раскрытие/закрытие).
 */

function init() {
    if (!document.querySelector('[data-sync-columns="users-list"]')) return;

    const $ = window.jQuery || window.$;
    if (!$) {
        console.error('[manager-users-list] jQuery not loaded');
        return;
    }

    $(() => {
        // Поиск по таблицам пользователей
        $('#adm_search_input').on('keyup', function () {
            const searchText = $(this).val().toLowerCase();
            $('.adm_table_m01 tbody tr').each(function () {
                const row = $(this);
                if (row.text().toLowerCase().indexOf(searchText) > -1) {
                    row.show();
                } else {
                    row.hide();
                }
            });
        });

        $('.adm_search_button').on('click', function (e) {
            e.preventDefault();
            $('#adm_search_block').toggleClass('active');
            if ($('#adm_search_block').hasClass('active')) {
                $('#adm_search_input').focus();
            }
        });

        // Dropdown проектов
        $('.adm_r_project_caption').on('click', function (e) {
            e.stopPropagation();
            const $item = $(this).closest('.adm_r_project_item');
            $('.adm_r_project_item').not($item).removeClass('open');
            $item.toggleClass('open');
        });

        $(document).on('click', function (e) {
            if (!$(e.target).closest('.adm_r_project_item').length) {
                $('.adm_r_project_item').removeClass('open');
            }
        });

        $('.adm_r_project_dropdown').on('click', function (e) {
            e.stopPropagation();
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
